import React from 'react';
import { Button, Dialog, toast } from 'day8-ui';
import { RxCross1 } from '@react-icons/all-files/rx/RxCross1';
import { useProfileEditModal } from '../../../context/ProfileEditModalContext';
import ProfileEditForm from './ProfileEditForm';
var ProfileEditModal = function () {
    var _a = useProfileEditModal(), isModalOpen = _a.isModalOpen, close = _a.close, modalProps = _a.modalProps;
    var handleSuccess = function (response) {
        toast.success((response === null || response === void 0 ? void 0 : response.message) || 'Profile updated.');
        if (modalProps === null || modalProps === void 0 ? void 0 : modalProps.onSuccess) {
            modalProps.onSuccess();
        }
        close();
    };
    return (React.createElement(Dialog, { open: isModalOpen, onOpenChange: function (open) { return !open && close(); }, scrollable: true, dialogType: "FULLSCREEN_MOBILE", title: (React.createElement("div", { className: "dui-flex dui-justify-between dui-items-center dui-mb-6" },
            React.createElement("h2", { className: "dui-text-2xl" }, "Complete your profile"),
            React.createElement(Button, { buttonType: "LINK", leftIcon: React.createElement(RxCross1, null), onClick: close, "aria-label": "Close" }))) }, isModalOpen && (React.createElement("div", { className: "yw-account" },
        React.createElement(ProfileEditForm, { onSuccess: handleSuccess })))));
};
export default ProfileEditModal;
